module.exports = __webpack_public_path__ + "img/sort-a-to-z-white.e7b3cfe6.svg";